import { Component, Input } from '@angular/core';
import { BaseToolComponent } from '../../base-tool.component';
import { UserImageData } from 'src/app/data/user/user-image.data';
import { ApplicationService } from 'src/app/services/application.service';
import { LabelData } from 'src/app/data/configurator/label/label.data';
import { LayerData } from 'src/app/data/configurator/layer/layer.data';
import { ImageLayerData } from 'src/app/data/configurator/layer/image-layer.data';
import { CommandData } from 'src/app/data/configurator/command.data';
import { HistoryData } from 'src/app/data/configurator/history.data';
import { UserData } from 'src/app/data/user.data';
import { Rectangle } from 'src/app/tools/rectangle';
import { RatioUtil } from 'src/app/tools/ratio.utils';
import { ContextData } from 'src/app/data/context.data';
import { ApplicationData } from 'src/app/data/application.data';
import { UserService } from 'src/app/services/user.service';
import { ModalService } from 'src/app/services/modal.service';

declare const fabric: any;

@Component({
  selector: 'image-panel',
  templateUrl: './image-panel.component.html',
  host: {
    class: 'image-panel'
  }
})
export class ImagePanelComponent extends BaseToolComponent {

  @Input() set label(data: LabelData) {
    if ((this._labelData && this._labelData != data) || !this._labelData) {
      this.clearCurrentLabel();
      this._labelData = data;
      this.setLabel();
    }
  }

  @Input() set layer(data: LayerData) {
    if (this._layerData != data) {
      this._layerData = data;
      this.setLayer();
    }
  }
  get layerData(): LayerData {
    return this._layerData;
  }

  public maxSize:number = 50;
  public currentSize: number = 0;


  /**
	 * Constructor
	 */
  constructor(
    private applicationService: ApplicationService,
    private applicationData: ApplicationData,
    public modalService:ModalService,
    public userService:UserService,
    public userData:UserData
  ) {
    super();
    this.computeCurrentSize();
  }

	/**
	 * On init
	 */
  ngOnInit() {
  }

  /**
	 * Set layer
	 */
  protected setLayer(): void {
    if (this._layerData && this._layerData.type == LayerData.IMAGE) {

    }
  }

  computeCurrentSize() {
    this.currentSize = 0;
    this.userData.images.map((uid:UserImageData)=>{
      this.currentSize += uid.size / 1024 / 1024;
    });
  }

  /**
   * Upload images
   */
  upload(file:File) {

    let _fileSizeMo:number = file.size / 1024 / 1024;

    if(_fileSizeMo > 5){
      this.modalService.open('modal-image-error', {
        text : 'cfg_alertImageFileSize',
        replaceList : {"limit":'5'}
      });
      return;
    } else if((this.currentSize + _fileSizeMo) > 50){
      this.modalService.open('modal-image-error', {
        text : 'cfg_alertImageQuotaExceeded'
      });
      return;
    }

    let reader = new FileReader();
    reader.onload = (e: any) => {

      let img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = () => {
        if(Math.max(img.width, img.height) > 4096){
          this.modalService.open('modal-image-error', {
            text : 'cfg_alertImageSize'
          });
        } else {
          this.userService.uploadImage(file).then((uid:UserImageData)=>{
            this.userData.images.push(uid);
            this.computeCurrentSize();
          }, (error)=>{
            this.modalService.open('modal-image-error', {
              text : error
            });
          });
        }
      };
      img.onerror = (error) => {
        console.warn(error);
        this.modalService.open('modal-image-error', {
          text : 'cfg_imageImportFail1'
        });
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);

  }

  /**
   * Browse images
   */
  browse(event:any) {

    if(this.userData.id > 0){
      this.upload(event.target.files[0]);
    } else {
      this.userService.invokeLogin().then(()=>{
        this.upload(event.target.files[0]);
      },(error)=>{
        // Do nothing
      });
    }

    return true;
  }

  /**
	 * addImageLayer
	 */
  public addImageLayer(data:UserImageData) {

    // console.log("addImageLayer");

    this.prepareImage(data).then(()=>{

      let _displayWidth = NaN;
      let _displayHeight = NaN;
      if(data.width > 0){

        // si image plus grande que l'étiquette
        let _imgRect = new Rectangle(0,0,data.width*ContextData.PIXELS_TO_MM,data.height*ContextData.PIXELS_TO_MM);
        let _labelRect = new Rectangle(0,0,this.applicationService.data.configuration.currentLabel.width,this.applicationService.data.configuration.currentLabel.height);
        if(_imgRect.width > _labelRect.width || _imgRect.height > _labelRect.height){
          let _imgMaxRect = new Rectangle(0,0,_labelRect.width,_imgRect.height);
          // étiquette fine, on fit dans un carré moyen sans quoi l'image est trop petite, ça ressemble à rien)
          if((_labelRect.width/_imgRect.height)<0.2 || (_labelRect.width/_imgRect.height)>6){
            _imgMaxRect = new Rectangle(0,0,(_labelRect.width + _imgRect.height)*.5,(_labelRect.width + _imgRect.height)*.5);
          }
          let _rectFit = RatioUtil.scaleToFit(_imgRect,_imgMaxRect);
          _displayWidth = _rectFit.width;
          _displayHeight = _rectFit.height;
        } else {
          _displayWidth = _imgRect.width;
          _displayHeight = _imgRect.height;
        }
        // console.log(_imgRect, _labelRect, _displayWidth, _displayHeight)
      }

      // var layerData: LayerData = new ImageLayerData(data, null, null);
      var layerData: LayerData = new ImageLayerData(data, null, null,0, 0,_displayWidth,_displayHeight,);
      layerData.rotation = this.applicationData.configuration.currentCanvasRotation.valueOf()*-1;
      var locks: Object = { position: false, rotation: false, size: false, deletion: false, depth: false, tint: true };
      layerData.locks = locks;
      this._labelData.addLayer(layerData);

      HistoryData.add(this._labelData, layerData, CommandData.REMOVE_LAYER);

      setTimeout(() => { this.applicationService.currentLayerData = layerData; }, 100);
    });

  }

  prepareImage(data:UserImageData){
    return new Promise((resolve, reject) => {
      if(data.base64){
        resolve(data);
      }else{
        let img = new Image();
        img.crossOrigin = 'Anonymous';
        img.onload = () => {
          let targetWidth;
          let targetHeight;
          if(Math.max(img.width,img.height) > fabric.textureSize){
            let _imgRect = new Rectangle(0,0,img.width,img.height);
            let _imgMaxRect = new Rectangle(0,0,fabric.textureSize,fabric.textureSize)
            let _rectFit = RatioUtil.scaleToFit(_imgRect,_imgMaxRect)
            targetWidth = _rectFit.width;
            targetHeight = _rectFit.height;
          } else {
            targetWidth = img.width;
            targetHeight = img.height;
          }
          var canvas = document.createElement("canvas");
          canvas.width = targetWidth;
          canvas.height = targetHeight;
          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, targetWidth, targetHeight);
          var dataURL = canvas.toDataURL("image/png");
          data.base64 = dataURL;
          data.width = targetWidth;
          data.height = targetHeight;
          resolve(true);
        };
        img.onerror = (err) => {
          reject(err);
        };
        img.src = data.url;
      }
    });
  }

	/**
	* On destroy
	*/
  ngOnDestroy() {

  }
}
